import React from 'react'
import PropTypes from 'prop-types'
import './ErrorBoundary.css'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    // Surface the error so it shows up in console and Sentry/whatever
    // tooling the team wires up later. No silent failures.
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] Render error caught:', error, errorInfo)
  }

  handleReload = () => {
    window.location.reload()
  }

  handleGoHome = () => {
    // HashRouter — reset to the root hash and clear the boundary state.
    window.location.hash = '#/'
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children
    }

    const errorMessage = this.state.error?.message || 'Unknown error'

    return (
      <main className="eb-page has-grain" role="alert" aria-labelledby="eb-title">
        <div className="eb-content">
          <div className="eb-glyph" aria-hidden>
            ⚠
          </div>
          <h1 id="eb-title" className="eb-title fluid-headline">Something broke</h1>
          <p className="eb-subtitle fluid-subhead">
            The interface ran into an error and couldn&apos;t finish rendering. Refreshing usually clears it.
          </p>
          <details className="eb-details">
            <summary className="eb-summary">Technical detail</summary>
            <pre className="eb-trace">{errorMessage}</pre>
          </details>
          <div className="eb-actions">
            <button
              type="button"
              className="eb-button eb-button--primary"
              onClick={this.handleReload}
            >
              Reload page
            </button>
            <button
              type="button"
              className="eb-button eb-button--ghost"
              onClick={this.handleGoHome}
            >
              Take me home
            </button>
          </div>
        </div>
      </main>
    )
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ErrorBoundary
